import { put, call } from 'redux-saga/effects';
import { fetchActiveBenefits } from '@epi-repositories/BenefitGroupSettingsRepository';
import { ApiConstants } from '@epi-constants/actions';

export function* getActiveBenefits() {
  try {
    const response = yield call(fetchActiveBenefits);

    // Remove when endpoint returns benefit types with first letter upper case
    const activeBenefitTypes = response.map(
      type => type.charAt(0).toUpperCase() + type.slice(1)
    );

    yield put({
      type: `${ApiConstants.GET_ACTIVE_BENEFITS}_SUCCESS`,
      payload: activeBenefitTypes
    });
  } catch (ex) {
    yield put({
      type: `${ApiConstants.GET_ACTIVE_BENEFITS}_FAILURE`,
      payload: ex
    });
  }
}
